exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/backend/src/app/phone/config/providers/components/provider-caller-id/provider-caller-id.component.scss
// module id = ../../../../../src/app/phone/config/providers/components/provider-caller-id/provider-caller-id.component.scss
// module chunks = main